import { useState } from 'react'
import { Notice } from '../Toast'
import { useMutation, useQuery } from '@tanstack/react-query'
import { changePassword, getMe } from '../api/endpoints'
import { ErrorNotice } from '../components'
import { ROLE_LABELS } from '../lib/format'

export default function AccountPage() {
  const me = useQuery({ queryKey: ['me'], queryFn: getMe })
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const change = useMutation({ mutationFn: () => changePassword(current, next), onSuccess: () => { setCurrent(''); setNext('') } })
  return (
    <div>
      <h1>Account</h1>
      {me.data && <p className="muted">Roles: {me.data.roles.map((r) => ROLE_LABELS[r] ?? r).join(', ')}</p>}
      <form className="card" style={{ maxWidth: 420 }} onSubmit={(e) => { e.preventDefault(); change.mutate() }}>
        <h2>Change password</h2>
        <label className="field">Current password<input type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} /></label>
        <label className="field">New password (12+ characters)<input type="password" autoComplete="new-password" minLength={12} required value={next} onChange={(e) => setNext(e.target.value)} /></label>
        <ErrorNotice error={change.error} />
        {change.isSuccess && <Notice tone="ok">Password changed.</Notice>}
        <button className="primary" type="submit" disabled={change.isPending}>Change password</button>
      </form>
    </div>
  )
}
